import { sendEmail } from "@/services";
import { clinicCrud, patientCrud, testCrud, userCrud } from "@/services/firebase";
import { Clinic, ClinicAdmin, Doctor, Patient, Test } from "@/types/database";
import { Values as FormValues} from "../components/TestReviewForm";
import { createPatientTest } from "@/services/api";

export const fetchTestData = async (testId: string, user: Doctor) => {
  if(user.role !== 'doctor' || !testId) throw new Error('Only doctors can review valid tests');

  const [test, clinicAdmin] = await Promise.all( [
    testCrud.read(testId) as Promise<Test>,
    userCrud.read([['managedClinicId', '==', user.associatedClinicIds?.[0]]]) as Promise<ClinicAdmin>,
  ]);

  const [patient, clinic] = await Promise.all( [
    patientCrud.read(test.patientId) as Promise<Patient>,
    clinicCrud.read(test.clinicId) as Promise<Clinic>,
  ]);

  return { test, clinicAdmin, patient, clinic };
}

interface ReviewEntities {
  clinicAdmin: ClinicAdmin
  doctor: Doctor
  patient: Patient 
  clinic: Clinic 
  test: Test
}

export const submitReview = async (action: FormValues['action'], {clinicAdmin, doctor, patient, clinic, test}: ReviewEntities, notes?: string) => {
   let patientDOB = '';
  if(patient.dob) {
    patientDOB = patient.dob.toDate().toLocaleString('en-US').split(',')[0];
  }
  
  const reviewProps = {
    notes,
    name: clinicAdmin.name,
    doctorName: doctor.name,
    patientLastName: patient.lastName,
    facilityName: clinic.name,
    patientDOB,
  };

  let patientStatus: Patient['status'];

  switch(action) {
    case 'ok':
      await sendEmail({
        to: patient?.email as string,
        templateName: 'clinic-admin-all-good',
        props: reviewProps
      });
      patientStatus = 'reviewed';
      break;

    case 'come-to-clinic':
      await sendEmail({
        to: clinicAdmin.email as string,
        templateName: 'clinic-admin-in-person-evaluation',
        props: reviewProps,
      });
      patientStatus = 'come-to-clinic';
      break;

    case 'retake-test': {
      const newTest = await createPatientTest(patient, doctor.id);
      const notes = reviewProps.notes
      await sendEmail({
        to: patient.email as string,
        templateName: "patient-resubmit-test",
        props: { ...patient, testId: newTest.id, facilityName: clinic.name, notes },
      });
      
      patientStatus = 'pending-patient';
      break;
    }
    case 'cannot-be-performed':
      await sendEmail({
        to: clinicAdmin.email as string,
        templateName: 'clinic-admin-patient-cant-be-performed',
        props: reviewProps,
      });

      patientStatus = 'cant-be-performed';
      break;
  }

  testCrud.update(test.id, {
    status: patientStatus,
    notes,
  });

  patientCrud.update(patient.id, {
    status: patientStatus
  })

};